import BuildConfig from '$extensionSrc/buildConfig'

import { AUTOMATION_STAGE_STATUSES } from '../genericAutomationStageStatuses'

export const TWITTER_AUTOMATION_STAGE_STATUSES = {
  ...AUTOMATION_STAGE_STATUSES,
  FINDING_POSTS_TO_DELETE: {
    body: 'Please keep this tab open.',
    progress: 'This may take a minute depending on how many posts you have.',
    title: `${BuildConfig.TENANT_NAME} is finding posts to delete...`,
  },
  DELETING_ALL_POSTS: {
    body: 'Please keep this tab open.',
    progress:
      "We'll send you an alert when everything's finished. This might take a little while depending on how many posts you have.",
    title: `${BuildConfig.TENANT_NAME} is deleting your posts...`,
  },
  LEAVING_DIRECT_MESSAGES: {
    body: 'Please keep this tab open.',
    progress:
      "We'll send you an alert when everything's finished. This might take a little while depending on how many direct messages you have.",
    title: `${BuildConfig.TENANT_NAME} is leaving your direct messages...`,
  },
  DELETING_LIKES: {
    body: 'Please keep this tab open.',
    progress:
      "We'll send you an alert when everything's finished. This might take a little while depending on how many likes you have.",
    title: `${BuildConfig.TENANT_NAME} is deleting your likes...`,
  },
  BLOCKING_REPOSTERS: {
    body: 'Please keep this tab open.',
    progress:
      'This might take a little while depending on how many reposters there are.',
    title: `${BuildConfig.TENANT_NAME} is checking who to block...`,
  },
}
